// Shared color palette presets for the AI Report Builder (ReportBuilder.jsx,
// AIReportBuilderModal.jsx) and the Admin Panel's Tenant Brand Colors editor.
// Single source of truth so the preset list/colors never drift between the two.
//
// Note: no entry is labeled "(Default)" here — which preset is the *effective* default
// is contextual (a tenant's configured Brand Colors take precedence when present, this
// list's first entry otherwise), so that qualifier is added dynamically by the caller
// instead of being baked into a name.
export const PALETTE_PRESETS = [
  {
    id: 'default',
    name: 'Primary Blue Brand',
    primary: '#093070',
    secondary: '#6fca42',
    accent: '#fdbc13'
  },
  {
    id: 'emerald',
    name: 'Emerald Mint',
    primary: '#0f766e',
    secondary: '#10b981',
    accent: '#f59e0b'
  },
  {
    id: 'purple',
    name: 'Modern Purple',
    primary: '#581c87',
    secondary: '#8b5cf6',
    accent: '#ec4899'
  },
  {
    id: 'slate',
    name: 'Corporate Slate',
    primary: '#1e293b',
    secondary: '#475569',
    accent: '#0ea5e9'
  },
  {
    id: 'rose',
    name: 'Crimson Rose',
    primary: '#881337',
    secondary: '#e11d48',
    accent: '#f59e0b'
  },
  {
    id: 'custom',
    name: 'Custom Palette...',
    primary: '#093070',
    secondary: '#6fca42',
    accent: '#fdbc13'
  }
];

// The same presets minus the "Custom Palette..." bookkeeping entry — for pickers that
// offer "start from this preset" (e.g. Tenant Brand Colors), where "Custom" isn't a
// real palette to copy colors from.
export const BRAND_SOURCE_PRESETS = PALETTE_PRESETS.filter(p => p.id !== 'custom');
